export const OPCIONES_RETENCIONES_RENTA = [
  {
    Id: 2,
    Nombre: '2,00%',
    Color: 'text-cendiatra-verde-3 font-bold',
  },
  {
    Id: 11,
    Nombre: '11,00%',
    Color: 'text-cendiatra-verde-3 font-bold',
  },
]

export const OPCIONES_SOBRETASA_BOMBERIL = [
  {
    Id: 6,
    Nombre: '6,00%',
    Color: 'text-cendiatra-verde-3 font-bold',
  },
  {
    Id: 15,
    Nombre: '15,00%',
    Color: 'text-cendiatra-verde-3 font-bold',
  },
]

export const OPCIONES_RETENCIONES_IVA = [
  {
    Id: 15,
    Nombre: '15,00%',
    Color: 'text-cendiatra-verde-3 font-bold',
  },
]
